import React from "react";
import './style.scss'
import { useTranslation } from "react-i18next";

const ConfidentialMessage = () => {
    const{t}=useTranslation();
    return (
      <div className="confidentialMessage">
        {t('Confidential-message')}
      </div>
    );
  };
  
  export default ConfidentialMessage;